import { ACESS_ROLE_ADMINISTRATOR } from "../../../../../business/constants";

type AccessItem = {
  accessId: string;
  accessName: string;
  grant: boolean | null;
};

type AccessRoleData = {
  isOwner: boolean;
  roleId: string;
  accesses?: AccessItem[];
};

export type AccessRoleState = {
  accessRole?: {
    data?: {
      data?: AccessRoleData | null;
    } | null;
  } | null;
  error?: unknown;
  errorShow?: boolean;
  loading?: boolean;
};

const getAccessRoleData = (
  accessRoleState: AccessRoleState,
): AccessRoleData | null => accessRoleState?.accessRole?.data?.data ?? null;

// TODO: extender con el roleId de Nominista cuando se exponga en business/constants.js (PBI #772850).
export const canApplyRequests = (accessRoleState: AccessRoleState): boolean => {
  const data = getAccessRoleData(accessRoleState);
  if (!data) return false;

  if (data.isOwner === true) return true;
  if (data.roleId === ACESS_ROLE_ADMINISTRATOR) return true;

  return false;
};
